import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import pdfLogo from '../assets/img/pdf-tool/logo@2x.png';
import * as selectors from '../dff/dff-selectors';
import { Toolbar } from '../toolbar/toolbar-component';
import { userSelector } from '../user/user-slice';
import { MainMenuComponent } from '../menu/main-menu';

require('./pdf-tool.scss');

export interface PdfToolStateProps {}

export interface PdfToolDispatchProps {}

export interface PdfToolOwnProps {}

export interface PdfToolProps
  extends PdfToolStateProps,
    PdfToolDispatchProps,
    PdfToolOwnProps {
  history: any;
}

export const PdfToolComponent: React.FC<PdfToolProps> = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const user = useSelector(userSelector);

  useEffect(() => {
    document.title = 'Koofr EXP - PDF Tool';
  }, []);

  // useEffect(() => {
  //   console.log(user);
  //   if (user) {
  //     return;
  //   }
  //   fetch('/api/v2/user/appconfig')
  //     .then((results) => {
  //       if (results.ok) {
  //         return results.json();
  //       }
  //       throw new Error(results.status as any);
  //     })
  //     .then((data) => {
  //       dispatch(loadUser(data));
  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       setIsLoading(false);
  //     });
  // }, []);

  return (
    <div className="pdf-tool">
      <Toolbar>
          <div className='l-toolbar__column'>
            <Link to="/">
              <img src={pdfLogo} alt="Koofr DFF logo" className="l-toolbar__logo"/>
            </Link>
            <div className='divider'></div>
            <div className='app-name'>PDF Tool</div>
          </div>
          <div className='l-toolbar__column stretch'></div>
          <div className='l-toolbar__column'>
            { user ? 
              (
                <>
                  <div className='divider'></div>
                  <MainMenuComponent/>
                </>
              )
              : null
            }
          </div>
        </Toolbar>
      <div className="pdf-tool-container">
        <h1>Work with PDFs in your Koofr</h1>
        <h2>Manage your PDF files saved in Koofr.</h2>

        {!isLoading && !user ? (
          <a
            href={`/login?redirect=${encodeURIComponent('/pdf-tool/')}`}
            className="login-button"
          >
            Sign in with Koofr
          </a>
        ) : null}

        {user !== null && user.extra.subscription.isPayingUser ? (
          <div className="pdf-tool__tools-container">
            <Link to="/pdf-tool/split/" className="pdf-tool__tool-card">
              <div className="pdf-tool__tool-card__icon pdf-tool__tool-card__icon--split"></div>
              <div className="pdf-tool__tool-card__right">
                <div className="text-lg font-semibold mb-1">Split PDF</div>
                <div className="text-base mb-2.5 text-color-text">
                  Split your PDF document in one or multiple pages into multiple
                  PDF files.
                </div>
                <div className="btn-green">
                  Split
                </div>
              </div>
            </Link>
            <Link to="/pdf-tool/merge/" className="pdf-tool__tool-card">
              <div className="pdf-tool__tool-card__icon pdf-tool__tool-card__icon--merge"></div>
              <div className="pdf-tool__tool-card__right">
                <div className="pdf-tool__tool-card__title">Merge PDF</div>
                <div className="text-base mb-2.5 text-color-text">
                  Merge your PDF documents into one. You can rotate them and
                  choose the order.
                </div>
                <div className="btn-green">
                  Merge
                </div>
              </div>
            </Link>
          </div>
        ) : null}

        {!isLoading && user && !user.extra.subscription.isPayingUser ? (
          <div className="upgrade">
            <p className="upgrade__text">
              Koofr PDF Tool is only available to paying users.
            </p>
            <a
              href="https://app.koofr.net/app/account"
              className="login-button"
            >
              Upgrade your account
            </a>
          </div>
        ) : null}
      </div>
    </div>
  );
};
